import { Breadcrumbs, Grid } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { CustomBreadcrumb } from "../../components/common/CustomBreadcrumb/CustomBreadcrumb";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useInitialStepStore } from "../../hooks/useInitialStepStore";
import { InitialStep } from "../../types/slices/initialStepType";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { InitialStepModal } from "./InitialStepModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'description', label: 'Descripción', align: 'center' },
    { type: 'text', field: 'plans', label: 'Planes', align: 'center', format: (row) => row.plans.map((plan, index) => `${index + 1}. ${plan.charAt(0).toUpperCase() + plan.slice(1)}\n`) },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

export const InitialStepList: FC = () => {

    const navigate = useNavigate()
    const { status, initialSteps, getInitialSteps, deleteInitialStep, setSelectedInitialStep } = useInitialStepStore()

    const [action, setAction] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [rowSelected, setRowSelected] = useState<any>('')
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [searchTimeout, setSearchTimeout] = useState<any>(null)
    const [search, setSearch] = useState<string>('')

    useEffect(() => {
        getInitialStepApi()
    }, [search])

    const getInitialStepApi = async () => {
        setLoading(true)
        let payload: any = {}
        if (search !== '') {
            payload = {
                search
            }
        }
        await getInitialSteps(payload)
        setLoading(false)
    }

    const onAdd = () => {
        setSelectedInitialStep({} as InitialStep)
        setAction('create')
        setShowModal(true)
    }

    const onEdit = (rowSelected) => {
        setSelectedInitialStep(rowSelected)
        setAction('edit')
        setShowModal(true)
    }

    const onDelete = (rowSelected: any) => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true)
    }

    const onDeleteConfirm = async () => {
        setLoading(true)
        setShowModalConfirm(false)
        await deleteInitialStep(rowSelected.id)
        await getInitialStepApi()
        setLoading(false)
    }

    const onDetails = (rowSelected) => {
        setSelectedInitialStep(rowSelected)
        setAction('detail')
        setShowModal(true)
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { setSearch(term) }, 1000)
        )
    }

    return (<>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 3 }}>
            <CustomBreadcrumb label={"Maestros"} />
            <CustomBreadcrumb label={"Pasos iniciales"}
                onClick={() => {
                    navigate({ pathname: RoutesMap.INITIAL_STEP_LIST })
                }}
            />
        </Breadcrumbs>
        <Grid item xs={12}>
            <CustomTable
                title={'Pasos iniciales'}
                columns={columns}
                loading={loading}
                rows={initialSteps || []}
                onRowClick={() => { }}
                hasOptions
                onAddFn={onAdd}
                onAddFnName={'Nuevo paso inicial'}
                onDetails={onDetails}
                onDelete={onDelete}
                onEdit={onEdit}
                onSearch={onSearch}
                dense
            />
        </Grid>
        {
            showModalConfirm && (
                <ModalConfirm
                    open={showModalConfirm}
                    closeModal={() => { setShowModalConfirm(false) }}
                    onConfirm={onDeleteConfirm}
                    status={status === ApiStatus.FETCHING}
                />
            )
        }
        {
            showModal &&
            <InitialStepModal
                open={showModal}
                closeModal={() => { setShowModal(false) }}
                onList={() => getInitialStepApi()}
                action={action}
            />
        }
    </>)
}